export default __webpack_public_path__ + "static/media/home-image-button-online-donations.0f219e50.jpg";